import Table from "../../components/Table";
import Layout from "../../components/Layout";
import { useAnalytics } from "../../features/analytics/analyticsProvider";

export default function ApiKeysPage() {
  const { analytics } = useAnalytics();
  return (
    <Layout metaTitle="Organization API Keys">
      <Table
        url="/d/apikeys/org_apikey/"
        formURL="/d/apikeys/org_apikey/form/"
        tableName="Organization API Key"
        tableDescription="Organization keys are mainly to authenticate organization level requests such as Account APIs."
        onAddItemSuccessfully={() => {
          analytics.track("user_api_key_created", {
            key_type: "organization",
          });
        }}
      />
    </Layout>
  );
}

ApiKeysPage.parentPath = "/api-keys";
